<template>
  <v-app-bar
    fixed
    app
    permanent
    dense
    dark
    class="app-bar"
    clipped-right
    clipped-left
  >
    <v-tabs
      dark
    >
      <v-tabs-slider class="app-bar-slider"></v-tabs-slider>
      <v-tab link to="/tribune">
        Трибуны
      </v-tab>
      <v-tab link to="/speech_constructor">
        Конструктор речи
      </v-tab>
      <v-tab link to="/learn">
        Учебник
      </v-tab>
    </v-tabs>
    <v-spacer></v-spacer>
    <v-menu
      bottom
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>
            mdi-account
          </v-icon>
        </v-btn>
      </template>

      <v-list width="200px">
        <v-list-item link dense to="/profile">
          <v-list-item-icon>
            <v-icon color="#1f51a4">mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Профиль</v-list-item-title>
        </v-list-item>
        <v-list-item link dense @click="logout">
          <v-list-item-icon>
            <v-icon color="#1f51a4">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Выйти</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>
</template>

<script>
export default {
  name: 'Head',
  methods: {
    logout () {
      this.$store.dispatch({
        type: 'logoutRequest'
      })
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/colors";
.app-bar {
  background-color: $itmo-blue!important;
}
.app-bar-slider {
  background-color: $itmo-red!important;
}
</style>
